import React from 'react';
import { Button, Dialog, Text, TextTypography } from '@wix/wix-ui-tpa/cssVars';
import { useExpressCheckoutButtonsData } from '../../provider/useExpressCheckoutButtonsData';
import { translate } from '../../utils/translate';
import { classes } from './ExpressCheckoutErrorModal.st.css';
export let ExpressCheckoutErrorModalDataHooks = /*#__PURE__*/function (ExpressCheckoutErrorModalDataHooks) {
  ExpressCheckoutErrorModalDataHooks["Root"] = "ExpressCheckoutErrorModal.Root";
  ExpressCheckoutErrorModalDataHooks["Title"] = "ExpressCheckoutErrorModal.Title";
  ExpressCheckoutErrorModalDataHooks["Body"] = "ExpressCheckoutErrorModal.Body";
  ExpressCheckoutErrorModalDataHooks["ActionButton"] = "ExpressCheckoutErrorModal.ActionButton";
  return ExpressCheckoutErrorModalDataHooks;
}({});
const TITLE_KEY = 'expressCheckout.alertDialog.physicalProducts.title';
const BODY_KEY = 'expressCheckout.alertDialog.physicalProducts.description';
const BUTTON_KEY = 'expressCheckout.alertDialog.physicalProducts.cta';
export const ExpressCheckoutErrorModal = _ref => {
  let {
    isOpen,
    onClose
  } = _ref;
  const {
    translations
  } = useExpressCheckoutButtonsData();
  const t = key => translate(translations, key);
  return /*#__PURE__*/React.createElement(Dialog, {
    "data-hook": ExpressCheckoutErrorModalDataHooks.Root,
    isOpen: isOpen,
    onClose: onClose
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement(Text, {
    "data-hook": ExpressCheckoutErrorModalDataHooks.Title,
    typography: TextTypography.largeTitle
  }, t(TITLE_KEY)), /*#__PURE__*/React.createElement(Text, {
    "data-hook": ExpressCheckoutErrorModalDataHooks.Body,
    typography: TextTypography.runningText
  }, t(BODY_KEY))), /*#__PURE__*/React.createElement(Button, {
    "data-hook": ExpressCheckoutErrorModalDataHooks.ActionButton,
    className: classes.button,
    onClick: onClose
  }, t(BUTTON_KEY))));
};
//# sourceMappingURL=ExpressCheckoutErrorModal.js.map